module.exports = __webpack_public_path__ + "static/media/GPG292A_R92_VW.8d803398.jpg";